import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=09ae3f9c&scoped=true&"
import script from "./Performance.vue?vue&type=script&lang=ts&"
export * from "./Performance.vue?vue&type=script&lang=ts&"
import style0 from "./Performance.vue?vue&type=style&index=0&id=09ae3f9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae3f9c",
  null
  
)

export default component.exports